//Last Modified: 2024/03/27 11:50:15

import Chart from '@/chart'
import { pdfFontSize } from '@/assets/js/settings'

import { horizontalStratification } from '@/assets/charts/plugins/backgroundStratification.js'


export function parseData(data, target_states) {
    // Datasets are constructed before the chart is initialised, they are then parsed here
    const result = data.map((values, index) => {
        return 100 * values[target_states[index]]
    })

    return result
}

export function initChart(ctx, labels, states, data, params, pdf = false) {


    data = data[0] ? data : data.map(() => states.map(() => 0))

    
    const datasets = parseData(data, params.target_states).map((value, index) => {
        return {
            label: labels[index],
            data: [value],
            backgroundColor: 'black'
        }
    })
    //console.log("datasets:", datasets)
    const options = getOptions(params, pdf)

    //console.log("options", options)
    const config = {
        type: 'gauge',
        data: {
            datasets
        },
        options: options,
        plugins: [horizontalStratification]
    }

    return new Chart(ctx, config);
}


function getOptions(params, pdf = false) {
    let options = {
        responsive: true,
        tooltips: {
            mode: 'index',
            intersect: false,
          },
         hover: {
            mode: 'nearest',
            intersect: true
          },
        indexAxis: 'y',
        scales: {
            x: {
                stacked: true,
                min: 0,
                max: params.truncatedMax ? params.truncatedMax : 100, // This exists for backwards compatibility with existing interfaces that don't have a truncatedMax param instantiated
                ticks: {
                    callback: function (value) {
                        var lastValue = (params.truncatedMax ? params.truncatedMax : 100)
                        var displayValue = (value === lastValue && value < 100)? `≥${value}%` : `${value}%`;
                        return displayValue
                    }
                }
            },
            y: {
                display: false
            }
        },
        plugins: {
            horizontalStratification: {
                // These are the values passed into the plugin
                // Only values listed here may be accessed
                strata: params.strata,
                pallete: params.strataColor,
                scaleStrata: 0.8,
                truncatedMax: params.truncatedMax
            },
            legend: {
                display: false
            }
        },
        pallete: [
            "rgba(52, 162, 40, 1)",
            "rgba(172, 198, 58, 1)",
            "rgba(228, 208, 32, 1)",
            "rgba(230, 130, 53, 1)",
            "rgba(203, 55, 52, 1)"
        ],
        strata: [20, 20, 20, 20, 20],
        strataColor: [
            "rgba(52, 162, 40, 1)",
            "rgba(172, 198, 58, 1)",
            "rgba(228, 208, 32, 1)",
            "rgba(230, 130, 53, 1)",
            "rgba(203, 55, 52, 1)"
        ],
        strataNames: [
            "Very low risk",
            "Low risk",
            "Medium risk",
            "High risk",
            "Very high risk"
        ],
        truncatedMax: 100
    }

    if (pdf) {
        options.animation = false
        options.responsive = false
        options.scales.x.ticks['font'] = {
            size: pdfFontSize
        }
        options.scales['x'] = {
            ticks: {
                font: {
                    size: pdfFontSize
                }
            }
        }
    }

    return options
}

export function pdfChart(ctx, labels, data, params = {}) {
    let pdf = true
    let states = params.states

    //console.log("data", data)
    //console.log("states", states)

    data = data[0] ? data : data.map(() => states.map(() => 0))

    //console.log("data2", data)

    const datasets = parseData(data, params.target_states).map((value, index) => {

        return {
            label: labels[index],
            data: [value],
            backgroundColor: 'black'
        }
    })

    //console.log("datasets", datasets)

    const options = getOptions(params, pdf)
    //console.log("options.strata", options.strata)
    const config = {
        type: 'gauge',
        data: {
            datasets
        },
        options: options,
        plugins: [horizontalStratification]
    }

    return new Chart(ctx, config);
}